export default __webpack_public_path__ + "static/sig-e5cd79383155895b31a125c05516a2b1.jpg";